export default Object.freeze({
  COMMON: 'COMMON',
})
